/**
 * Directive used to clear the session of a contact
 */
angular.module('westBerkshireEvents.logoutContact').directive('wbLogoutContact', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        controller: wbWaitForLogoutContact
    };
});

function wbWaitForLogoutContact($scope, halClient, $sessionStorage, $localStorage, LoginService) {

    // If the session user is a contact, clear the session by logging them out
    let memberJson = $sessionStorage.getItem('login');
    if (memberJson) {
        let member = halClient.createResource(memberJson);
        if (member.client_type == 'Contact') {
            const options = {
                root: $scope.bb.api_url
            }
            LoginService.logout(options).then(() => {
                $scope.logoutComplete = true;
            });
        } else if (member.client_type == 'Member') {
            $scope.logoutComplete = true;
        }
    } else {
        $scope.logoutComplete = true;
    }
}



// WEBPACK FOOTER //
// ../src/public/javascripts/logout-contact/logout_contact.directive.js